module.exports = __webpack_public_path__ + "media/icons/cash-receipt-71a1a36e.svg";